import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=27912c70&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&id=27912c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27912c70",
  null
  
)

export default component.exports